export enum LogoSize {
  xsmall = 'xs',
  small = 's',
  medium = 'm',
  large = 'l',
}

export enum LogoSurface {
  onBrand = 'onBrand',
  onPrimary = 'onPrimary',
  onPersistentDark = 'onPersistentDark',
}

export enum LogoBrand {
  loyalty = 'loyalty',
  main = 'main',
}

export enum LogoVariant {
  logotype = 'logotype',
  symbol = 'symbol',
}

export interface LogoHoCProps {
  children: React.ReactNode
  className?: string
  brand: LogoBrandType
  size: LogoSizeType
  surface: LogoSurfaceType
  variant: LogoVariantType
}

type LogoBrandType = `${LogoBrand}`
type LogoSizeType = `${LogoSize}`
type LogoSurfaceType = `${LogoSurface}`
type LogoVariantType = `${LogoVariant}`

export interface LogoProps extends Omit<LogoHoCProps, 'children' | 'brand'> {}
